exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PersonalDataStatus_content_16So {\n  display: grid;\n  grid-template-columns: auto auto;\n  grid-gap: 8px;\n\n  -webkit-box-pack: justify;\n\n  -webkit-justify-content: space-between;\n\n      -ms-flex-pack: justify;\n\n          justify-content: space-between;\n}\n", ""]);

// exports
exports.locals = {
	"content": "PersonalDataStatus_content_16So"
};